var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('checkbox',{attrs:{"name":_vm.name,"id":_vm.id,"label":_vm.label,"disabled":_vm.disabled,"value":_vm.value},on:{"input":_vm.changed}})}
var staticRenderFns = []

export { render, staticRenderFns }